import { Actions, Entities } from '@hotmart/space-lib/dist/datahub'
import animationData from 'src/assets/animations/reaction.json'

export const LIMIT_CHARACTER_PUBLICATION = 200

export const COMMUNITY_DEFAULT_IMAGE =
  'https://static.club.hotmart.com/club-drive-ui/images/empty-home.png'

export const AVATAR_SIZE = 40

export const AMOUNT_MORE_POSTS = 6

export const ROWS_POST_PER_PAGE = 8

export const POSITION = {
  BOTTOM: 'bottom',
  RIGHT: 'right'
}

export const ACCESS_TO_POST = {
  COMMUNITY_POST_LISTING: 'community_post_listing',
  COMMUNITY_POST_FEED: 'community_post_feed',
  MEMBERSHIP_HOME: 'membership_home',
  DIRECT_ACCESS: 'direct_access',
  PUSH_NOTIFICATION: 'push_notification',
  MORE_LIKE_THIS: 'more_like_this',
  USER_PROFILE: 'user_profile',
  CLASSROOM: 'classroom'
}

export enum Language {
  EN = 'en',
  ES = 'es',
  PT = 'pt',
  FR = 'fr'
}

export const COMMUNITY_CREATION_SURVEY = 'app-space:communityCreationSurvey'

export const OWNER = 'OWNER'

export const MEDIAS_PROCESSING_KEY = 'mediasProcessingTemp'

export const CHECK_POST_STATUS_INTERVAL_KEY = 'checkPostStatusIntervalId'

export const BIND_EXCLUSIVE_COMMUNITY_SURVEY = 'app-space:bindExclusiveCommunitySurvey'

export const medias = {
  image: { 'image/jpeg': ['.jpeg', '.jpg'], 'image/png': ['.png'] },
  pdf: { 'application/pdf': ['.pdf'] },
  video: {
    'video/mp4': ['.mp4'],
    'video/avi': ['.avi'],
    'video/x-flv': ['.flv'],
    'video/x-msvideo': ['.avi'],
    'video/x-divx': ['.divx'],
    'video/3gpp': ['.3gp'],
    'video/quicktime': ['.mov', '.qt'],
    'video/x-ms-wmv': ['.wmv'],
    'video/webm': ['.webm'],
    'video/matroska': ['.mkv'],
    'video/x-matroska': ['.mkv'],
    'video/divxplus': ['.mp4', '.MP4'],
    'video/mkv': ['.mkv']
  },
  audio: {
    'audio/mpeg': ['.mp3'],
    'audio/aac': ['.aac'],
    'audio/ogg': ['.ogg'],
    'application/ogg': ['.ogg'],
    'audio/x-m4a': ['.m4a'],
    'audio/m4a': ['.m4a']
  }
}

export const defaultOptionsEmojiPicker = {
  autoplay: true,
  loop: false,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}

export const CommunitiesEventsPayload = {
  ADD: {
    group: Entities.HOME_COMMUNITY,
    name: Actions.COMMUNITY_ADD
  },
  EDIT: {
    group: Entities.HOME_COMMUNITY,
    name: Actions.COMMUNITY_EDIT
  },
  DELETE: {
    group: Entities.HOME_COMMUNITY,
    name: Actions.COMMUNITY_DELETE
  }
}

export const USER_INFO_KEY = 'app-space-userInfo'
export const USER_INFO_KEY_OPT2 = 'app-space:userInfo'
export const USER_ROLE = 'app-space-user-role'
export const MIGRATION_SUCCESS_KEY = 'app-space:migration-success'
export const MIGRATION_SHOULD_OPEN_SIDEBAR = 'app-space:migration-should-open-sidebar'
export const PUBLIC_COMMUNITY_MEMBER_ASSOCIATION = 'app-space:public-community-member-association'
export const PUBLIC_COMMUNITY_MEMBER_ASSOCIATION_SCREEN_NAME =
  'app-space:public-community-member-association-screen-name'
export const PUBLIC_COMMUNITY_MEMBER_ASSOCIATION_COMPONENT_SOURCE =
  'app-space:public-community-member-association-component-source'
export const PUBLIC_COMMUNITY_STORED_COMMENT = 'app-space:public-community-stored-comment'
export const MAIN_HEADER_HEIGHT = '65px'
export const VIEW_AS_BAR_HEADER = '82px'
